<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     日期范围选择器
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-date-picker
    v-model="pickedRange"
    class="f-date-range-picker "
    :pop-class="border"
    type="daterange"
    unlink-panels
    range-separator="至"
    :start-placeholder="splaceholder"
    :end-placeholder="eplaceholder"
    value-format="timestamp"
    :style="{ width: width + 'px' }"
    :picker-options="options"
    @change="handleChange" />
</template>

<script>
const today = new Date(new Date().toLocaleDateString()).getTime()

// 获取当前时间戳（毫秒）
const currentTimestamp = new Date().getTime();
// 创建当前日期对象
const currentDate = new Date(currentTimestamp);
// 获取当前月份的第一天
const currentMonth = new Date(
  currentDate.getFullYear(),
  currentDate.getMonth(),
  1
).getTime();
// 获取当前月份的最后一天
const lastDayOfMonth = new Date(
  currentDate.getFullYear(),
  currentDate.getMonth() + 1,
  0
).getTime();

// 获取上个月的第一天
const lastMonth = new Date(
  currentDate.getFullYear(),
  currentDate.getMonth() - 1,
  1
).getTime();
// 获取上上个月的第一天
const lastLastMonth = new Date(
  currentDate.getFullYear(),
  currentDate.getMonth() - 2,
  1
).getTime();
export default {
  name: 'FDateRangePicker',
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
    width: {
      type: String,
      default: '240'
    },
    range: {
      type: Array,
      default() {
        return []
      }
    },
    shortcuts: {
      type: Array,
      default() {
        return []
      }
    },

    border: {
      type: String,
      default: 'border'
    },

    splaceholder: {
      type: String,
      default: "开始日期",
    },

    eplaceholder: {
      type: String,
      default: "结束日期",
    },
  },
  data() {
    var disabledDate = (date) => {
      if (this.range) {
        if (this.range.length === 1) {
          return date.getTime() < this.range[0] * 1000
        } else {
          return date.getTime() < this.range[0] * 1000 || date.getTime() > this.range[1] * 1000
        }
      } else {
        return false
      }
    }
    const shortcuts = []
    const choices = [
      { text: '今天', num: 0 },
      { text: '最近一周', num: -7 },
			{ text: '最近一个月', num: -30 },
			{ text: '最近三个月', num: -90 },
			{ text: '最近六个月', num: -180 },
			{ text: '最近六个月', num: -360 },
			{ text: '昨天', num: -1 },			
			{ text: '明天', num: 1 },
      { text: '本周', num: 5 },
			{ text: '往后一周', num: 7 },
			{ text: '往后一个月', num: 30 },
			{ text: '往后三个月', num: 90 },
			{ text: '往后六个月', num: 180 },
			{ text: '往后六个月', num: 360 },
      { text: '本月', num: 2 },
      { text: '上月', num: 3 },
      { text: '上上月', num: 4 },
    ]
    if (this.shortcuts.length > 0) {
      for (const c of choices) {
        if (this.shortcuts.indexOf(c.num) > -1) {
          if (c.num == 2) {
            shortcuts.push({
              text: c.text,
              onClick(picker) {
                // let recent = today;
                picker.$emit("pick", [currentMonth, lastDayOfMonth]);
              },
            });
          } else if (c.num == 3) {
            shortcuts.push({
              text: c.text,
              onClick(picker) {
                picker.$emit("pick", [
                  lastMonth,
                  currentMonth - 3600 * 1000 * 24,
                ]);
              },
            });
          } else if (c.num == 4) {
            shortcuts.push({
              text: c.text,
              onClick(picker) {
                picker.$emit("pick", [
                  lastLastMonth,
                  lastMonth - 3600 * 1000 * 24,
                ]);
              },
            });
          } else if (c.num == 5) {
            shortcuts.push({
              text: c.text,
              onClick(picker) {
                const firstDayOfWeek = new Date(
                  currentDate.getFullYear(),
                  currentDate.getMonth(),
                  currentDate.getDate() - currentDate.getDay()
                ).getTime();
                picker.$emit("pick", [
                  firstDayOfWeek,
                  firstDayOfWeek + 3600 * 1000 * 24 * 6,
                ]);
              },
            });
          } else {
            shortcuts.push({
              text: c.text,
              onClick(picker) {
                picker.$emit('pick', [today + 3600 * 1000 * 24 * c.num, today])
              }
            })
          }
          
        }
      }
    }
    if (shortcuts.length) {
      return {
        options: {
          shortcuts: shortcuts,
          disabledDate: disabledDate
        }
      }
    } else {
      return {
        options: {
          disabledDate: disabledDate
        }
      }
    }
  },
  computed: {
    pickedRange: {
      get() {
        if (this.value !== null) {
          return [this.value[0] * 1000, this.value[1] * 1000]
        } else {
          return null
        }
      },
      set(val) {
        if (val !== null) {
          val[0] /= 1000
          val[1] = val[1] / 1000 + 86399
        }
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleChange(val) {
      this.$emit('change', val)
    }
  }
}
</script>

<style lang="scss" slot-scoped>
.f-date-range-picker {
  &.el-date-editor {
    .el-range-separator {
      width: 10%;
      color: #c0c4cc;
    }
  }
}
</style>
